"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepDescription = void 0;

var _atoms = require("../../../atoms");

var _VideoPlayer = require("../../VideoPlayer");

var _UploadMomentHeader = require("../UploadMomentHeader");

var _UploadMomentFooter = require("../UploadMomentFooter");

var _StepController = require("../../../molecules/StepController");

var _react = _interopRequireWildcard(require("react"));

var _VideoPreview = require("../VideoPreview");

var _molecules = require("../../../molecules");

require("./StepDescription.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// Step Description
var StepDescription = function StepDescription(_ref) {
  var name = _ref.name,
      tempMoment = _ref.tempMoment,
      updates = _ref.updates,
      onNextStep = _ref.onNextStep,
      buttonTitle = _ref.buttonTitle,
      onCloseClick = _ref.onCloseClick,
      onPreviousStep = _ref.onPreviousStep,
      showContentInMobile = _ref.showContentInMobile,
      uploading = _ref.uploading,
      uploadingProgress = _ref.uploadingProgress,
      canPlayLocalVideo = _ref.canPlayLocalVideo;
  // add spotlight to show in video
  var massagedTempMoment = tempMoment;

  if (updates.spotlightEnabled) {
    massagedTempMoment["spotlights"] = [{
      center: [updates.spotlightCenterX, updates.spotlightCenterY],
      corr: 0,
      height: 0,
      trace_number: "-1",
      utc: updates.spotlightStartAtUTC,
      width: 0
    }];
  } else {
    massagedTempMoment["spotlights"] = [];
  }

  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      nextButtonDisabled = _useState2[0],
      setNextButtonDisabled = _useState2[1];

  var _useState3 = (0, _react.useState)(updates.description),
      _useState4 = _slicedToArray(_useState3, 2),
      description = _useState4[0],
      setDescription = _useState4[1];

  var tags = updates.tags.filter(function (tag) {
    return tag.selected;
  });

  var _useState5 = (0, _react.useState)(updates.description !== null),
      _useState6 = _slicedToArray(_useState5, 2),
      didAdjust = _useState6[0],
      setDidAdjust = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = _slicedToArray(_useState7, 2),
      message = _useState8[0],
      setMessage = _useState8[1];

  var handleCloseClick = function handleCloseClick() {
    onCloseClick();
  };

  var handlePreviousStepClick = function handlePreviousStepClick() {
    if (typeof onPreviousStep === "function") {
      var newUpdates = {
        description: description,
        didAdjustDescription: didAdjust
      };
      onPreviousStep(newUpdates);
    }
  };

  var handleNextStepClick = function handleNextStepClick() {
    if (typeof onNextStep === "function") {
      var newDescription = description;
      if (newDescription) newDescription = description.trim();
      var newUpdates = {
        description: newDescription,
        didAdjustDescription: didAdjust
      };
      onNextStep(newUpdates);
    }
  };

  var handleTextAreaOnChange = function handleTextAreaOnChange(e) {
    setDidAdjust(true);
    setDescription(e.target.value);
  };

  var handleOnDisabledButtonClick = function handleOnDisabledButtonClick() {
    setMessage({
      type: "warning",
      title: "Please wait for your video to finish processing..."
    });
  }; // Handle display of content in mobile


  var showContentInMobileClassName = !showContentInMobile ? "mobile-hide" : ""; // Video timing & spotlight logic

  var momentDuration = updates.stopAtRelative - updates.startAtRelative; // Get video container ref

  var videoPlayerContainerRef = (0, _VideoPlayer.useVideoContainerRef)();

  var _useVideoInfo = (0, _VideoPlayer.useVideoInfo)(videoPlayerContainerRef),
      duration = _useVideoInfo.duration;

  if (updates.startAtRelative === 0 && updates.stopAtRelative === 0) {
    momentDuration = duration;
  }

  (0, _react.useEffect)(function () {
    var newDisabled = uploadingProgress !== 200;

    if (nextButtonDisabled !== newDisabled) {
      if (!newDisabled) {
        setNextButtonDisabled(false);
      } else {
        setNextButtonDisabled(true);
      }
    }
  }, [uploadingProgress, tempMoment]);
  return /*#__PURE__*/_react.default.createElement(_StepController.Step, {
    name: name
  }, /*#__PURE__*/_react.default.createElement(_atoms.Stack, {
    className: "StepDescription upload-moment-preview-container",
    xs: _atoms.Stack.Type.Column,
    sm: _atoms.Stack.Type.Column,
    md: _atoms.Stack.Type.Column,
    lg: _atoms.Stack.Type.Row
  }, /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "upload-moment-preview ".concat(showContentInMobileClassName)
  }, /*#__PURE__*/_react.default.createElement(_UploadMomentHeader.UploadMomentHeader, {
    title: "Add a description",
    className: "mobile",
    onBackClick: onPreviousStep,
    onCloseClick: handleCloseClick,
    steps: 5,
    index: 3
  }), /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "upload-moment-video-container"
  }, /*#__PURE__*/_react.default.createElement(_VideoPreview.VideoPreview, {
    moment: tempMoment,
    updates: updates,
    duration: momentDuration,
    containerRef: videoPlayerContainerRef
  }))), /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "upload-moment-controls",
    alignItems: "center",
    justifyContent: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    width: "100%"
  }, /*#__PURE__*/_react.default.createElement(_UploadMomentHeader.UploadMomentHeader, {
    title: "Add a description",
    className: "desktop",
    onBackClick: handlePreviousStepClick,
    onCloseClick: handleCloseClick,
    steps: 5,
    index: 5
  }), /*#__PURE__*/_react.default.createElement("textarea", {
    id: "upload-moment-description",
    value: description,
    placeholder: "Personalize your highlight...",
    onChange: handleTextAreaOnChange
  }), /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    justifyContent: "flex-start",
    className: "tags"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    className: "tags-label",
    color: _atoms.Color.Grey2,
    type: _atoms.Label.Type.Chip,
    bold: true,
    marginBottom: "2",
    width: "100%"
  }, "TAGS"), /*#__PURE__*/_react.default.createElement(_atoms.Row, null, tags.map(function (tag) {
    if (tag.title) {
      return /*#__PURE__*/_react.default.createElement(_molecules.Chip, {
        className: "Chip selected-tag",
        key: tag.game_clip_tag_id,
        content: tag.title,
        background: "grey4-color",
        color: "black-color",
        margin: "1",
        fat: 1,
        id: tag.name
      });
    } else {
      return null;
    }
  })))), /*#__PURE__*/_react.default.createElement(_UploadMomentFooter.UploadMomentFooter, {
    message: message,
    uploading: uploading,
    uploadingProgress: uploadingProgress,
    buttonTitle: buttonTitle,
    buttonDisabled: nextButtonDisabled,
    onButtonClick: handleNextStepClick,
    onDisabledButtonClick: handleOnDisabledButtonClick,
    canPlayLocalVideo: canPlayLocalVideo
  }))));
};

exports.StepDescription = StepDescription;
StepDescription.defaultProps = {
  showContentInMobile: true,
  onPreviousStep: null
};